import { render, staticRenderFns } from "./part_life_dialog.vue?vue&type=template&id=2bde0e6c"
import script from "./part_life_dialog.vue?vue&type=script&lang=js"
export * from "./part_life_dialog.vue?vue&type=script&lang=js"
import style0 from "./part_life_dialog.vue?vue&type=style&index=0&id=2bde0e6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports